<template>
  <div class="section-content section2">
    <div class="content-wrapper">
      <div class="glasses-display" :class="{'animate__show': isActive}">
        <img src="../assets/glasses2.png" alt="Smart Glasses Display">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Section2',
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.section-content {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100vh;
  background: #000;
  color: #fff;
  padding: 0;
  overflow: hidden;
}

.content-wrapper {
  width: 100%;
  margin: 0 auto;
  position: relative;
}

.glasses-display {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  opacity: 0;
  transform: scale(0.95);
  transition: all 0.8s ease;
}

.glasses-display img {
  max-width: 100%;
  height: auto;
}

.screen-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.screen-text {
  color: #42b983;
  font-size: 14px;
  max-width: 200px;
  text-align: center;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 5px;
}

.animate__animated {
  opacity: 0;
}
.animate__show {
  opacity: 1;
  transform: scale(1);
}

@media screen and (max-width: 768px) {
  .section-content {
    height: auto;
  }

  .content-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .glasses-display {
    width: 100%;
    padding: 0;
  }

  .glasses-display img {
    width: 100%;
    margin: 0 auto;
  }
}
</style> 